import React, { useState, useEffect } from 'react'
import PropTypes from 'prop-types'
import './MacStyleWindow.css'

import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'
import { faChevronLeft } from '@fortawesome/free-solid-svg-icons'

import closeIcon from '../../../assets/icons/close-icon.svg'
import maximizeIcon from '../../../assets/icons/fullscreen-icon.svg'
import minimizeIcon from '../../../assets/icons/minscreen-icon.svg'

import appStoreIcon from '../../../assets/icons/Documents/app-store-icon.png'
import desktopIcon from '../../../assets/icons/Documents/desktop-icon.png'
import documentsIcon from '../../../assets/icons/Documents/documents-icon.png'

import easestarLogo from '../../../assets/logos/easestar.png'
import easesoundLogo from '../../../assets/logos/easesound.png'

import PDFIcon from '../../PDFIcon/PDFIcon'
import PDFWindow from '../PDFWindow/PDFWindow'

import resumeIcon from '../../../assets/icons/Apps/resume-icon.png'

import AppItemComponent from '../../WindowContent/AppItemComponent/AppItemComponent'
import AppStoreWindowContent from '../../WindowContent/AppStoreWindowContent/AppStoreWindowContent'

import EaseStarInfoComponent from '../../WindowContent/EaseAppsInfoComponent/EaseStarInfoComponent'
import EaseSoundInfoComponent from '../../WindowContent/EaseAppsInfoComponent/EaseSoundInfoComponent'

function MacStyleWindow({ onClose, defaultMenu, children }) {
  const [isMaximized, setIsMaximized] = useState(false)
  const [selectedMenu, setSelectedMenu] = useState(defaultMenu)
  const [currentContent, setCurrentContent] = useState(null)
  const [openWindow, setOpenWindow] = useState(null)
  const [currentPdf, setCurrentPdf] = useState(null)
  const [appInfoOpen, setAppInfoOpen] = useState(false)
  const resumePdf =
    'https://chensitesbucket.s3.us-east-1.amazonaws.com/chenchen/resume.pdf'

  useEffect(() => {
    setSelectedMenu(defaultMenu) // Ensure the selected menu updates if the default changes
    handleMenuClick(defaultMenu)
  }, [defaultMenu])

  const toggleMaximize = () => {
    setIsMaximized(!isMaximized)
  }

  const handleMenuClick = key => {
    setSelectedMenu(key)
    // 根据选中的菜单项设置当前内容
    switch (key) {
      case 'desktop':
        setCurrentContent(
          <div className="macstyle-window-document-container">
            <PDFIcon
              icon={resumeIcon}
              label="Resume"
              pdf={resumePdf}
              onOpen={() => openPDFWindow(resumePdf)}
            />
          </div>
        ) // 替换为实际的内容
        break
      case 'appStore':
        setCurrentContent(
          <AppStoreWindowContent onAppClick={handleAppStoreClick} />
        )
        break
      case 'documents':
        setCurrentContent(
          <div className="macstyle-window-document-container">
            <PDFIcon
              icon={resumeIcon}
              label="Resume"
              pdf={resumePdf}
              onOpen={() => openPDFWindow(resumePdf)}
            />
          </div>
        )
        break
      default:
        setCurrentContent(null)
    }
  }

  const openPDFWindow = pdf => {
    setCurrentPdf(pdf)
    setOpenWindow('pdf')
  }

  const closePDFWindow = () => {
    setCurrentPdf(null)
    setOpenWindow(null)
  }

  const handleAppStoreClick = title => {
    setAppInfoOpen(true)
    const headerImage = title === 'EaseStar' ? easestarLogo : easesoundLogo
    setCurrentContent(
      <AppItemComponent headerImage={headerImage}>
        {title === 'EaseStar' && <EaseStarInfoComponent />}
        {title === 'EaseSound' && <EaseSoundInfoComponent />}
      </AppItemComponent>
    )
  }

  const handleBackClick = () => {
    if (selectedMenu === 'appStore') {
      setAppInfoOpen(false)
      setCurrentContent(
        <AppStoreWindowContent onAppClick={handleAppStoreClick} />
      )
    } else {
      setCurrentContent(null)
    }
  }

  const menuItems = [
    { key: 'desktop', label: 'Desktop', icon: desktopIcon },
    { key: 'appStore', label: 'App Store', icon: appStoreIcon },
    { key: 'documents', label: 'Documents', icon: documentsIcon },
  ]

  return (
    <div className="mac-window-overlay">
      <div className={`mac-window ${isMaximized ? 'maximized' : ''}`}>
        <div className="mac-window-sidebar">
          <div className="mac-window-buttons">
            <img
              className="close-icon"
              onClick={onClose}
              src={closeIcon}
              alt="Close"
              style={{ cursor: 'pointer', width: '12px', height: '12px' }}
            />
            <img
              className="close-icon"
              onClick={toggleMaximize}
              src={isMaximized ? minimizeIcon : maximizeIcon}
              alt="Close"
              style={{ cursor: 'pointer', width: '12px', height: '12px' }}
            />
          </div>

          <div className="mac-window-menu">
            {menuItems.map(item => (
              <div
                key={item.key}
                className={`mac-window-menu-item ${
                  selectedMenu === item.key ? 'active' : ''
                }`}
                onClick={() => {
                  handleMenuClick(item.key)
                  setAppInfoOpen(false)
                }}
              >
                <img
                  src={item.icon}
                  alt={`${item.label} Icon`}
                  className="mac-window-menu-icon"
                />
                {item.label}
              </div>
            ))}
          </div>
        </div>
        <div className="mac-window-content">
          <div
            className={`mac-window-content-header ${appInfoOpen ? 'app-info-open' : ''}`}
          >
            {appInfoOpen && (
              <div onClick={handleBackClick} className="back-button">
                <FontAwesomeIcon icon={faChevronLeft} />
              </div>
            )}
            {!appInfoOpen && (
              <div className="mac-window-content-header-title">
                {menuItems.find(item => item.key === selectedMenu)?.label ||
                  'Select a Menu'}
              </div>
            )}
          </div>

          <div className="mac-window-content-body">{currentContent}</div>

          {/* 条件渲染PDF窗口 */}
          {openWindow === 'pdf' && currentPdf && (
            <PDFWindow type="pdf" onClose={closePDFWindow}>
              <iframe
                src={currentPdf}
                title="PDF Viewer"
                style={{ width: '100%', height: '100%', border: 'none' }}
                type="application/pdf"
              />
            </PDFWindow>
          )}
        </div>
      </div>
    </div>
  )
}

MacStyleWindow.propTypes = {
  onClose: PropTypes.func.isRequired,
  defaultMenu: PropTypes.string, // Menu to open by default
  children: PropTypes.node,
}

export default MacStyleWindow
